import type { FlightAirport } from './types';

/** Compact airport label for UI, e.g. "LHR / EGLL". */
export function formatAirportLabel(airport: FlightAirport | null | undefined): string {
  if (!airport) return 'N/A';
  const iata = airport.iata?.trim();
  const icao = airport.icao?.trim();
  if (iata && icao) return `${iata} / ${icao}`;
  if (icao) return icao;
  if (iata) return iata;
  return 'N/A';
}

export function formatAirportDetail(airport: FlightAirport | null | undefined): string | null {
  if (!airport) return null;
  const parts = [airport.location, airport.name].filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}
